const NotificationStatusEnum = {
  Sending: 1,
  Received: 2,
};

export default Object.freeze(NotificationStatusEnum);
